import React from 'react'
import CurrentTagTitle from '../CurrentTagTitle'
import GridItem from '../GridItem'

import './style.scss'

class Grid extends React.Component {
  constructor(props) {
    super(props)

    this.handlers = {
      onMouseMove: this.onMouseMove.bind(this)
    }
  }

  componentDidMount() {
    this.grid = document.querySelector('.grid')

    this.scrollBarWidth = 0
    if (window.innerWidth > this.grid.clientWidth) {
      this.scrollBarWidth = window.innerWidth - this.grid.clientWidth
    }

    this.tagMenu = document.querySelector('.tag-menu')
    this.tagMenu.parentNode.removeChild(this.tagMenu)

    this.maxWidthItem = 80
    this.allItems = this.props.factsData.length + 1 /* logoItem */ + 1 /* tagMenuItem */
    this.sqrtAllItems = Math.sqrt(this.allItems)
    this.numberItemInColumn = Math.round(this.sqrtAllItems)
    this.numberItemInRow = Math.ceil(this.allItems/this.numberItemInColumn)

    this.updateGrid()
    window.addEventListener('resize', this.updateGrid.bind(this))
    window.addEventListener('updateGrid', this.updateGrid.bind(this))
  }

  onMouseMove(event) {
    const scale = 1.2
    const maxTilt = 10
    const coefficientX = maxTilt/(this.widthItem * scale)
    const coefficientY = maxTilt/(this.heightItem * scale)
    const currentItemGrid = event.currentTarget.parentNode
    const position = event.currentTarget.getBoundingClientRect()

    let mousePositionX = event.clientX - position.left
    let mousePositionY = event.clientY - position.top

    let rotateX = mousePositionY * coefficientY - (maxTilt/2) > maxTilt/2 ?
        maxTilt/2 : mousePositionY * coefficientY - (maxTilt/2)
    let rotateY = ((mousePositionX * coefficientX - (maxTilt/2)) * -1) > maxTilt/2 ?
        maxTilt/2 : ((mousePositionX * coefficientX - (maxTilt/2)) * -1)

    window.requestAnimationFrame(function animation() {
      currentItemGrid.style.transform =
          'perspective(300px)' +
          'rotateX(' + rotateX + 'deg)' +
          'rotateY(' + rotateY + 'deg)' +
          'scale3d(' + scale + ', ' + scale + ', ' + scale + ')'
      currentItemGrid.style.willChange = 'transform'
      window.requestAnimationFrame(animation)
    })
  }

  updateGrid() {
    this.getItemSize()
    document.querySelectorAll('.item-empty').forEach(event => event.parentNode.removeChild(event))
    if (this.props.currentTag === 'all') {
      this.allItems = this.props.factsData.length + 1 /* logoItem */ + 1 /* tagMenuItem */
    } else {
      this.allItems = this.props.factsData.length
    }

    // Добавление меню тегов в крайнее правое верхнее место.
    if (this.tagMenu) {
      while ((this.heightItem * 1.5) > this.widthItem) {
        this.numberItemInColumn--
        this.numberItemInRow = Math.ceil(this.allItems/this.numberItemInColumn)
        this.getItemSize()
      }

      while ((this.widthItem + (this.widthItem * 20) / 100) > this.heightItem) {
        this.numberItemInColumn++
        this.numberItemInRow = Math.ceil(this.allItems/this.numberItemInColumn)
        this.getItemSize()
      }

      this.numberOfEmptyItems = this.numberItemInColumn * this.numberItemInRow - this.allItems

      // Высчитывание места для добавления меню тегов
      let numberItemInColumn = Math.floor((this.grid.offsetWidth - this.scrollBarWidth)/this.maxWidthItem)
      if (numberItemInColumn <= this.numberItemInColumn) {
        this.numberItemInColumn = numberItemInColumn
      }
      this.grid.insertBefore(this.tagMenu, this.grid.querySelectorAll('.item')[this.numberItemInColumn - 1])

      this.tagMenu.style.flexBasis = this.widthItem + 'px'
      document.querySelectorAll('.item').forEach((item) => {
        item.style.flexBasis = this.widthItem + 'px'
      })

      // Добавление пустых блоков для правильной ширины блоков сетки в последнем ряду
      for (let i = 0; i < this.numberOfEmptyItems; i++) {
        const emptyItem = document.createElement('div')
        emptyItem.classList.add('item-empty')
        emptyItem.style.flexBasis = this.widthItem + 'px'
        this.grid.appendChild(emptyItem)
      }
    }

    //TODO Отрефакторить, если будет время.
    let row = 1;
    if (this.props.currentTag === 'all') {
      for (let i = 2; i < this.allItems - 1; i++) {
        this.grid.querySelectorAll('.item')[i].classList
          .remove('first-line', 'first-in-line', 'last-line', 'last-in-line')

        if (i < this.numberItemInColumn) {
          this.grid.querySelectorAll('.item')[i - 1].classList.add('first-line')
        }

        if (i >= (this.numberItemInRow - 1) * this.numberItemInColumn - 1) {
          this.grid.querySelectorAll('.item')[i].classList.add('last-line')
        }

        if (i === this.numberItemInColumn * row) {
          this.grid.querySelectorAll('.item')[i - 1].classList.add('first-in-line')

          if (i > this.numberItemInColumn) {
            this.grid.querySelectorAll('.item')[i - 2].classList.add('last-in-line')
          }
          row++
        }

        if (i === this.allItems - 2 && !this.numberOfEmptyItems) {
          this.grid.querySelectorAll('.item')[i].classList.add('last-in-line')
        }
      }
    } else {
      let lastLine = 1
      for (let i = 1; i < this.allItems + 1; i++) {
        this.grid.querySelectorAll('.item')[i].classList
          .remove('first-line', 'first-in-line', 'last-line', 'last-in-line')

        if (i <= this.numberItemInColumn) {
          this.grid.querySelectorAll('.item')[i].classList.add('first-line')
        }

        if (i > (this.numberItemInRow - 1) * this.numberItemInColumn) {
          this.grid.querySelectorAll('.item')[i].classList.add('last-line')
          if (lastLine === 1) {
            this.grid.querySelectorAll('.item')[i].classList.add('first-in-line')
          }
          lastLine++
        }

        if (i === this.numberItemInColumn * row) {
          this.grid.querySelectorAll('.item')[i].classList.add('last-in-line')
          this.grid.querySelectorAll('.item')[i - this.numberItemInColumn + 1].classList.add('first-in-line')
          row++
        }
      }
    }
  }

  getItemSize() {
    this.heightItem = Math.floor(this.grid.offsetHeight/this.numberItemInRow)
    this.widthItem = Math.floor((this.grid.offsetWidth - this.scrollBarWidth)/this.numberItemInColumn)
    if (this.widthItem < this.maxWidthItem) {
      this.widthItem = this.maxWidthItem
    }
  }

  render() {
    return (
      <div className="grid-wrapper">
        <div
          className={['grid' + (this.props.partial ? ' partial' + (this.props.currentTag === 'quiz' ? ' grid-quiz' : '') : '')]}>
          {
            this.props.partial &&
            <CurrentTagTitle
              {...this.props}
            />
          }

          <div className="item logo" onClick={() => this.props.openModal('default')}/>
          {
            this.props.factsData.map((item, index) => {
              return (
                <GridItem
                  {...this.handlers}
                  {...this.props}
                  item={item}
                  key={index}
                  gridQuiz={item.quiz}
                />
              )
            })
          }
        </div>
        <div className="temporary-images">
          {
            this.props.factsData.map((item, index) => {
              return (
                <img alt="" src={require(`../../assets/images/facts/${index + 1}/mini.png`)} key={index}/>
              )
            })
          }
        </div>
      </div>
    )
  }
}

export default Grid
